import { render, staticRenderFns } from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=template&id=b7d41324"
import script from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js"
export * from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=script&lang=js"
import style0 from "./ChatActiveChatContentDetailsSidedbar.vue?vue&type=style&index=0&id=b7d41324&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports